import { apiConstants, typeOfInterventions } from './shared/config';

let routes = [
];

typeOfInterventions.forEach((work) => {
    if (work.active === true) {
        let route = {
            path: `/${apiConstants.code}/${work.basePath}/home/:code?`,
            name: `${apiConstants.code}.${work.basePath}.home`,
            props: { group: work.basePath },
            component: () => import(/* webpackChunkName: "gim-home" */ "./views/home.vue"),
            meta: { title: "home.title" },
        };
        if(work.acl) {
            route.meta.auth = {
                roles: [work.acl],
                redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado'
            };
        }
        routes.push(route);
    }
});

export default routes;